import Modal from 'react-bootstrap/Modal';
import { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { RaceClass } from '../constants/Regulation';

const UpdateStartNumberModal = ({
  onEditStartNumber,
  currentStartNumber,
  onHide,
  currentCategory,
  competitionRacingNumberClassInterval,
  ...rest
}) => {
  const [startNumber, setStartNumber] = useState(currentStartNumber);
  const [startNumberValidation, setStartNumberValidation] = useState({ isValid: true, validationMessage: '' });

  useEffect(() => {
    setStartNumber(currentStartNumber);
  }, [currentStartNumber]);

  if (!competitionRacingNumberClassInterval || !competitionRacingNumberClassInterval.intervals || !currentCategory) {
    return null;
  }

  const matchingRaceClass = Object.values(RaceClass).find(
    (raceClass) => raceClass.Id === currentCategory
  );

  const currentInterval = competitionRacingNumberClassInterval.intervals.find(
    (interval) => { return interval.raceClasses.includes(matchingRaceClass?.Id) }
  );

  // Calculate the valid range for the current category
  const minValidNumber = currentInterval ? currentInterval.startingRacingNumber : 0;
  const maxValidNumber =
    currentInterval && currentInterval.startingRacingNumber
      ? (competitionRacingNumberClassInterval.intervals.indexOf(currentInterval) === competitionRacingNumberClassInterval.intervals.length - 1
        ? Infinity
        : competitionRacingNumberClassInterval.intervals[
          competitionRacingNumberClassInterval.intervals.indexOf(currentInterval) + 1
        ].startingRacingNumber - 1)
      : Infinity;

  // Function to check if the entered number is within the valid range
  const isValidNumber = (number) => {
    return number >= minValidNumber && number <= maxValidNumber;
  };

  const handleEditStartNumber = () => {
    onEditStartNumber(startNumber);
    onHide();
  };

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Ändra startnummer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className='mt-2'>
            <Form.Label>Startnummer</Form.Label>
            <Form.Control
              type='number'
              name='Startnummer'
              value={startNumber}
              onChange={(e) => {
                setStartNumber(e.target.value)
                if (isNaN(e.target.value) || !isValidNumber(e.target.value)) {
                  setStartNumberValidation({ isValid: false, validationMessage: 'Startnummer faller utanför det tillåtna spannet för tävlingsklassen' })
                } else {
                  setStartNumberValidation({ isValid: true, validationMessage: '' })
                }
              }}
            />
          </Form.Group>
        </Form>
        {!startNumberValidation.isValid && startNumberValidation.validationMessage && (<p className='mt-2'>{startNumberValidation.validationMessage}</p>)}
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button onClick={handleEditStartNumber} className='mt-2' disabled={!startNumberValidation.isValid}>
          Spara
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateStartNumberModal;
